import * as sections from 'constants/sections';
import { i18n } from 'config/locales';

export const SUBSTANCE_USE = {
  key: sections.SUBSTANCE_USE,
  name: 'substance',
  path: 'substance',
  store: 'Substance',
  label: i18n.t('substance.section.name'),
};

export const SUBSTANCE_USE_INTRO = {
  key: sections.SUBSTANCE_USE_INTRO,
  name: 'intro',
  path: 'intro',
  label: i18n.t('substance.subsection.intro'),
};

export const SUBSTANCE_USE_DRUGS = {
  key: sections.SUBSTANCE_USE_DRUGS,
  name: 'drugs',
  path: 'drugs',
  label: i18n.t('substance.subsection.drugs.label'),
};

export const SUBSTANCE_USE_DRUGS_INTRO = {
  key: sections.SUBSTANCE_USE_DRUGS_INTRO,
  name: 'drugs/intro',
  path: 'intro',
  label: i18n.t('substance.subsection.intro'),
};

export const SUBSTANCE_USE_DRUGS_USAGE = {
  key: sections.SUBSTANCE_USE_DRUGS_USAGE,
  name: 'drugs/usage',
  path: 'usage',
  storeKey: 'DrugUses',
  label: i18n.t('substance.subsection.drugs.usage'),
};

export const SUBSTANCE_USE_DRUGS_PURCHASE = {
  key: sections.SUBSTANCE_USE_DRUGS_PURCHASE,
  name: 'drugs/purchase',
  path: 'purchase',
  storeKey: 'DrugInvolvements',
  label: i18n.t('substance.subsection.drugs.purchase'),
};

export const SUBSTANCE_USE_DRUGS_CLEARANCE = {
  key: sections.SUBSTANCE_USE_DRUGS_CLEARANCE,
  name: 'drugs/clearance',
  path: 'clearance',
  storeKey: 'DrugClearanceUses',
  label: i18n.t('substance.subsection.drugs.clearance'),
};

export const SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY = {
  key: sections.SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY,
  name: 'drugs/publicsafety',
  path: 'publicsafety',
  storeKey: 'DrugPublicSafetyUses',
  label: i18n.t('substance.subsection.drugs.publicsafety'),
};

export const SUBSTANCE_USE_DRUGS_MISUSE = {
  key: sections.SUBSTANCE_USE_DRUGS_MISUSE,
  name: 'drugs/misuse',
  path: 'misuse',
  storeKey: 'PrescriptionUses',
  label: i18n.t('substance.subsection.drugs.misuse'),
};

export const SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT = {
  key: sections.SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT,
  name: 'drugs/negativeimpact',
  path: 'negativeimpact',
  storeKey: 'NegativeImpact',
  label: i18n.t('substance.subsection.drugs.negativeImpact'),
};

export const SUBSTANCE_USE_DRUGS_ORDERED = {
  key: sections.SUBSTANCE_USE_DRUGS_ORDERED,
  name: 'drugs/ordered',
  path: 'ordered',
  storeKey: 'OrderedTreatments',
  label: i18n.t('substance.subsection.drugs.ordered'),
};

export const SUBSTANCE_USE_DRUGS_VOLUNTARY = {
  key: sections.SUBSTANCE_USE_DRUGS_VOLUNTARY,
  name: 'drugs/voluntary',
  path: 'voluntary',
  storeKey: 'VoluntaryTreatments',
  label: i18n.t('substance.subsection.drugs.voluntary'),
};

export const SUBSTANCE_USE_CONTROLLED_ILLEGAL_USAGE = {
  key: sections.SUBSTANCE_USE_CONTROLLED_ILLEGAL_USAGE,
  name: 'drugs/supplementalusage',
  path: 'supplementalusage',
  storeKey: 'IllegalControlledSubstanceUse',
  label: i18n.t('substance.subsection.drugs.supplementalUsage'),
};

export const SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE = {
  key: sections.SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE,
  name: 'drugs/supplementalpublicsafety',
  path: 'supplementalpublicsafety',
  storeKey: 'EmployedIllegalControlledSubstanceUse',
  label: i18n.t('substance.subsection.drugs.supplementalPublicSafety'),
};

export const SUBSTANCE_USE_ALCOHOL = {
  key: sections.SUBSTANCE_USE_ALCOHOL,
  name: 'alcohol',
  path: 'alcohol',
  label: i18n.t('substance.subsection.alcohol.label'),
};

export const SUBSTANCE_USE_ALCOHOL_INTRO = {
  key: sections.SUBSTANCE_USE_ALCOHOL_INTRO,
  name: 'alcohol/intro',
  path: 'intro',
  label: i18n.t('substance.pvq.subsection.alcohol.intro'),
};

export const SUBSTANCE_USE_ALCOHOL_NEGATIVE = {
  key: sections.SUBSTANCE_USE_ALCOHOL_NEGATIVE,
  name: 'alcohol/negative',
  path: 'negative',
  storeKey: 'NegativeImpacts',
  label: i18n.t('substance.subsection.alcohol.negative'),
};

export const SUBSTANCE_USE_ALCOHOL_ORDERED = {
  key: sections.SUBSTANCE_USE_ALCOHOL_ORDERED,
  name: 'alcohol/ordered',
  path: 'ordered',
  storeKey: 'OrderedCounselings',
  label: i18n.t('substance.subsection.alcohol.ordered'),
};

export const SUBSTANCE_USE_ALCOHOL_VOLUNTARY = {
  key: sections.SUBSTANCE_USE_ALCOHOL_VOLUNTARY,
  name: 'alcohol/voluntary',
  path: 'voluntary',
  storeKey: 'VoluntaryCounselings',
  label: i18n.t('substance.subsection.alcohol.voluntary'),
};

export const SUBSTANCE_USE_ALCOHOL_ADDITIONAL = {
  key: sections.SUBSTANCE_USE_ALCOHOL_ADDITIONAL,
  name: 'alcohol/additional',
  path: 'additional',
  storeKey: 'ReceivedCounselings',
  label: i18n.t('substance.subsection.alcohol.additional'),
};

export const SUBSTANCE_USE_ALCOHOL_SUPPLEMENTAL = {
  key: sections.SUBSTANCE_USE_ALCOHOL_SUPPLEMENTAL,
  name: 'alcohol/supplemental',
  path: 'supplemental',
  storeKey: 'AlcoholCounselings',
  label: i18n.t('substance.subsection.alcohol.any'),
};

export const SUBSTANCE_USE_REVIEW = {
  key: sections.SUBSTANCE_USE_REVIEW,
  name: 'review',
  path: 'review',
  label: i18n.t('substance.subsection.review'),
};

export const SUBSTANCE_USE_THC = {
  key: sections.SUBSTANCE_USE_THC,
  name: 'thc',
  path: 'thc',
  label: i18n.t('substance.subsection.thc.label'),
};
export const SUBSTANCE_USE_THC_INTRO = {
  key: sections.SUBSTANCE_USE_THC_INTRO,
  name: 'thc/intro',
  path: 'intro',
  label: i18n.t('substance.subsection.intro'),
};

export const SUBSTANCE_USE_THC_USAGE = {
  key: sections.SUBSTANCE_USE_THC_USAGE,
  name: 'thc/usage',
  path: 'usage',
  storeKey: 'ThcUses',
  label: i18n.t('substance.subsection.thc.usage'),
};

export const SUBSTANCE_USE_THC_PURCHASE = {
  key: sections.SUBSTANCE_USE_THC_PURCHASE,
  name: 'thc/purchase',
  path: 'purchase',
  storeKey: 'ThcInvolvements',
  label: i18n.t('substance.subsection.thc.purchase'),
};

export const SUBSTANCE_USE_THC_CLEARANCE = {
  key: sections.SUBSTANCE_USE_THC_CLEARANCE,
  name: 'thc/clearance',
  path: 'clearance',
  storeKey: 'ThcClearanceUses',
  label: i18n.t('substance.subsection.thc.clearance'),
};

export const SUBSTANCE_USE_THC_PUBLIC_SAFETY = {
  key: sections.SUBSTANCE_USE_THC_PUBLIC_SAFETY,
  name: 'thc/publicsafety',
  path: 'publicsafety',
  storeKey: 'ThcPublicSafetyUses',
  label: i18n.t('substance.subsection.thc.publicsafety'),
};

export default {
  SUBSTANCE_USE,
  SUBSTANCE_USE_INTRO,
  SUBSTANCE_USE_DRUGS,
  SUBSTANCE_USE_DRUGS_INTRO,
  SUBSTANCE_USE_DRUGS_USAGE,
  SUBSTANCE_USE_DRUGS_PURCHASE,
  SUBSTANCE_USE_DRUGS_CLEARANCE,
  SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY,
  SUBSTANCE_USE_DRUGS_MISUSE,
  SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT,
  SUBSTANCE_USE_DRUGS_ORDERED,
  SUBSTANCE_USE_DRUGS_VOLUNTARY,
  SUBSTANCE_USE_THC,
  SUBSTANCE_USE_THC_INTRO,
  SUBSTANCE_USE_THC_USAGE,
  SUBSTANCE_USE_THC_PURCHASE,
  SUBSTANCE_USE_THC_CLEARANCE,
  SUBSTANCE_USE_THC_PUBLIC_SAFETY,
  SUBSTANCE_USE_CONTROLLED_ILLEGAL_USAGE,
  SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE,
  SUBSTANCE_USE_ALCOHOL,
  SUBSTANCE_USE_ALCOHOL_INTRO,
  SUBSTANCE_USE_ALCOHOL_NEGATIVE,
  SUBSTANCE_USE_ALCOHOL_ORDERED,
  SUBSTANCE_USE_ALCOHOL_VOLUNTARY,
  SUBSTANCE_USE_ALCOHOL_ADDITIONAL,
  SUBSTANCE_USE_ALCOHOL_SUPPLEMENTAL,
  SUBSTANCE_USE_REVIEW,
};
